const getters = {
  SMART_CLASSIFIER_INTENTS: (state) => {
    return state.intents;
  },
};

export default getters;
